module.exports = __webpack_public_path__ + "img/bb_g3_body.24ce19d7.svg";